import { IMaterial } from '@/services/material';
import { CheckList } from '.';

export const titles = {
  BASIC_NAME: 'Complete basic information',
  BASIC_PHYSICAL: 'Add width and weight properties',
  NAME: 'Complete basic information',
  IMAGERY: 'Add material imagery',
  PRICING: 'Add pricing information',
  PROPERTIES: 'Add material properties',
  VENDORS: 'Add the suppliers of this material',
  WASHING: 'Add sufficient washing instructions',
};

export default [
  {
    title: titles.BASIC_NAME,
    isComplete: data => data.name && data.color && data.composition && data.origin,
    meta: {
      category: 'General Information',
    },
  },
  {
    title: titles.BASIC_PHYSICAL,
    isComplete: data => data.weight && data.width,
    meta: {
      category: 'General Information',
    },
  },
  {
    title: titles.IMAGERY,
    isComplete: data => !!data.assets.length,
    meta: {
      category: 'General Information',
    },
  },
  {
    title: titles.WASHING,
    isComplete: data => {
      return [
        data.sym_bleach,
        data.sym_dry_clean_solvent,
        data.sym_drying,
        data.sym_ironing_temp,
        data.sym_tumble_dry,
        data.sym_wash,
      ]
      .filter(symbol => !!symbol)
      .length > 4;
    },
    meta: {
      category: 'General Information',
    },
  },
  {
    title: titles.PRICING,
    isComplete: data => (
      data.prices.length
        && !data.prices.find(price => !price.amount || !price.category || !price.currency)
    ),
    meta: {
      category: 'General Information',
    },
  },
  {
    title: titles.PROPERTIES,
    isComplete: data => (
      data.properties
        && data.properties.length
        && !data.properties.find(prop => !prop.key || !prop.value)
    ),
    meta: {
      category: 'General Information',
    },
  },
  {
    title: titles.VENDORS,
    isComplete: data => data.vendors && data.vendors.length,
    meta: {
      category: 'General Information',
    },
  },
] as Array<CheckList<IMaterial>>;
